@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.workoutresults

import com.yogaaicoach.pages.workout.data.WorkoutService
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch
import kotlin.uuid.Uuid

internal class WorkoutResultsViewModel(
    private val workoutService: WorkoutService,
    private val applicationScope: CoroutineScope,
) {
    val selectedDifficulty = MutableStateFlow<Int?>(null)

    fun updateSelectedDifficulty(difficulty: Int) {
        selectedDifficulty.value = difficulty
    }

    fun onFinishWorkoutClick(workoutGuid: Uuid, onDone: () -> Unit) {
        applicationScope.launch {
            val d = selectedDifficulty.value
            if (d != null) workoutService.postWorkoutFeedback(workoutGuid, d)
        }
        onDone()
    }

    fun reset() {
        selectedDifficulty.value = null
    }
}
